import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";
const foods = [
  { name: 'Pizza 🍕', ingredients: { cheese: 2, dough: 3 } },
  { name: 'Cake 🍰', ingredients: { flour: 2, sugar: 1, eggs: 2 } },
  { name: 'Biryani 🍛', ingredients: { rice: 3, spice: 2, meat: 2 } },
  { name: 'Cookies 🍪', ingredients: { flour: 2, chocolate: 3 } },
  { name: 'Juice 🧳', ingredients: { fruit: 2, water: 1 } },
];

const ChefRatioKitchen = () => {
  const [currentFood, setCurrentFood] = useState(null);
  const [scale, setScale] = useState(1);
  const [dropped, setDropped] = useState({});
  const [score, setScore] = useState(0);
  const bowlContentRef = useRef(null);
  const speechRef = useRef(null);
  const ingredientsRef = useRef(null);

  useEffect(() => {
    nextOrder();
  }, []);

  const speak = (text) => {
    const msg = new SpeechSynthesisUtterance(text);
    msg.pitch = 1.2;
    msg.rate = 1;
    speechSynthesis.speak(msg);
  };

  const nextOrder = () => {
    const food = foods[Math.floor(Math.random() * foods.length)];
    const multiplier = Math.floor(Math.random() * 3) + 1;
    setCurrentFood(food);
    setScale(multiplier);
    const initialDropped = {};
    Object.keys(food.ingredients).forEach(key => initialDropped[key] = 0);
    setDropped(initialDropped);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const name = e.dataTransfer.getData('text/plain');
    if (dropped[name] !== undefined) {
      const updated = { ...dropped, [name]: dropped[name] + 1 };
      setDropped(updated);
      const totalItems = Object.values(updated).reduce((a, b) => a + b, 0);
      if (bowlContentRef.current) {
        bowlContentRef.current.style.height = `${Math.min(100, totalItems * 10)}%`;
      }
      checkAnswer(updated);
    }
  };

  const checkAnswer = (currentDropped) => {
    const correct = Object.entries(currentFood.ingredients).every(
      ([name, qty]) => currentDropped[name] === qty * scale
    );
    if (correct) {
      if (speechRef.current) speechRef.current.textContent = `Perfect! Enjoy your ${currentFood.name}`;
      speak(`Perfect! Enjoy your ${currentFood.name}`);
      setScore(score + 1);
      document.getElementById('successSound').play();
          const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      const overAdded = Object.entries(currentFood.ingredients).some(
        ([name, qty]) => currentDropped[name] > qty * scale
      );
      if (overAdded) {
        if (speechRef.current) speechRef.current.textContent = 'Oops! Wrong mix! Try again!';
        speak('Oops! You added too much. Sending to trash!');
        document.getElementById('failSound').play();
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>🍽️ Chef's Ratio Kitchen 🍽️</div>
      <div style={styles.gameContainer}>
        <div style={styles.leftPanel}>
          <h3>📋 Base Recipe</h3>
          <ul>
            {currentFood && Object.entries(currentFood.ingredients).map(([name, qty]) => (
              <li key={name}>{name} × {qty}</li>
            ))}
          </ul>
        </div>

        <div style={styles.centerPanel}>
          <div ref={speechRef} style={styles.speechBubble}>Welcome! Let’s get cooking!</div>
          <div style={styles.chef}>👨‍🍳</div>
          <div
            style={styles.bowl}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            <div ref={bowlContentRef} style={styles.bowlContent}></div>
          </div>

          <div ref={ingredientsRef}>
            {currentFood && Object.keys(currentFood.ingredients).map(name => (
              <div
                key={name}
                style={styles.ingredient}
                draggable
                onDragStart={(e) => e.dataTransfer.setData('text/plain', name)}
              >
                {name}
              </div>
            ))}
          </div>

          <button onClick={nextOrder} style={styles.button}>Next Order</button>
          <div>Score: {score}</div>
        </div>

        <div style={styles.rightPanel}>
          <h3>🎯 Order</h3>
          <div>{currentFood && `Make ${scale}× ${currentFood.name}`}</div>
        </div>
      </div>

      <audio id="successSound" src="https://www.soundjay.com/buttons/sounds/button-4.mp3" />
      <audio id="failSound" src="https://www.soundjay.com/button/sounds/beep-10.mp3" />
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Comic Sans MS, cursive',
    background: '#fffbe6',
    minHeight: '100vh',
    overflow: 'hidden',
  },
  header: {
    background: '#ff7043',
    padding: '1rem',
    color: 'white',
    textAlign: 'center',
    fontSize: '2rem',
  },
  gameContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    height: 'auto',
  },
  leftPanel: {
    flex: '1 1 200px',
    padding: '1rem',
    background: '#fff3e0',
    boxSizing: 'border-box',
    minWidth: '200px',
  },
  centerPanel: {
    flex: '2 1 400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fffde7',
    position: 'relative',
    padding: '1rem',
    boxSizing: 'border-box',
    minWidth: '300px',
  },
  rightPanel: {
    flex: '1 1 200px',
    padding: '1rem',
    background: '#ffe0b2',
    boxSizing: 'border-box',
    minWidth: '200px',
  },
  ingredient: {
    padding: '0.5rem 1rem',
    margin: '0.5rem',
    background: '#ffccbc',
    borderRadius: '10px',
    cursor: 'grab',
    fontSize: '1rem',
    border: '2px dashed #ff5722',
    userSelect: 'none',
  },
  bowl: {
    width: '80%',
    maxWidth: '300px',
    aspectRatio: '5 / 3',
    background: '#ffe082',
    borderRadius: '50% / 30%',
    border: '4px solid #00ff77',
    marginBottom: '5rem',
    marginTop:"10rem",
    position: 'relative',
    overflow: 'hidden',
  },
  bowlContent: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '0%',
    background: '#f57c00',
    transition: 'height 0.3s ease',
  },
  speechBubble: {
    position: 'absolute',
    top: '1rem',
    left: '1rem',
    background: 'white',
    border: '3px solid #ff5722',
    padding: '0.5rem',
    borderRadius: '10px',
    width: '80%',
    maxWidth: '250px',
    fontSize: '1rem',
  },
  chef: {
    position: 'absolute',
    bottom: '1rem',
    left: '1rem',
    fontSize: '4rem',
  },
  button: {
    padding: '0.5rem 1rem',
    marginTop: '1rem',
    fontSize: '1rem',
    background: '#ff7043',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};


export default ChefRatioKitchen;
